import {BackendApi} from '@/services/backend_api'

export default {
  getInPeriod (endpoint, startYear, endYear) {
    return BackendApi.getClient().get(`${endpoint}?startYear=${startYear}&endYear=${endYear}`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  getInYear (endpoint, year) {
    return BackendApi.getClient().get(`${endpoint}?year=${year}`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  getInYearForRespondents (endpoint, year, respondents) {
    return BackendApi.getClient().get(`${endpoint}?year=${year}&respondents=${respondents}`)
    .then(response => { return response })
    .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/report.js